import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Filter } from '../../../../models/filter.models';


@Component({
  selector: 'number',
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss']
})
export class NumberComponent implements OnInit {
  public numberFormGroup : any;
  constructor(
    public controlContainer: ControlContainer
  ) {
  }

  @Input() data : Filter;
  ngOnInit(): void {
    this.numberFormGroup = this.controlContainer.control
  }

}
